<template>
  <section class="service-section">
    <div class="service-container">
      <!-- Sidebar stays fixed width; hidden at ≤768px via its own CSS -->
      <ServicePackagesSidebar />

      <!-- Main content column -->
      <div class="content-col">
        <ServicePackageContent
          title="Business Website Package"
          startingPrice="$7,999"
          :overview="overview"
          :bullets="bullets"
          :note="note"
          cta-route="/schedule-a-meeting"
        />

        <!-- Mobile list appears under content only at ≤768px -->
        <MobileServicePackagesList />
      </div>
    </div>
  </section>
</template>

<script>
import ServicePackagesSidebar from '@/views/servicePackages/ServicePackagesSidebar.vue';
import ServicePackageContent from '@/views/servicePackages/ServicePackageContent.vue';
import MobileServicePackagesList from '@/views/servicePackages/MobileServicePackagesList.vue';

export default {
  name: 'BusinessWebsitePackage',
  components: { ServicePackagesSidebar, ServicePackageContent, MobileServicePackagesList },
  data() {
    return {
      overview:
        'We build SEO-friendly informational websites that establish credibility and make it easy for customers to learn about your company. Using a modern CMS template (WordPress, Webflow, Squarespace) customized to your brand, you get a professional online presence without unnecessary complexity.',
      bullets: [
        'A responsive website customized with your brand identity',
        'Core pages like Home, About, Services, Blog, and Contact',
        'CMS setup for easy content management',
        'SEO setup + Google Analytics for visibility',
        'A fast launch designed for credibility and trust',
      ],
      note:
        'This package is template-driven with brand customization. For custom wireframes and unique UI design, pair it with our Custom UX/UI Design Package.',
    };
  },
};
</script>

<style scoped>
.service-section { padding: 2rem 1rem; background: #f9fafb; }

/* Two-column layout: fixed 380px sidebar + flexible content */
.service-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

/* Wrap content and ensure it can shrink without overflow */
.content-col { min-width: 0; }

/* One-column at ≤768px (sidebar hidden by its own CSS) */
@media (max-width: 768px) {
  .service-container {
    grid-template-columns: 1fr;
  }
}
</style>
